import dayjs from 'core/utils/dayjs';
import config from '../configs';
import { PERSONALIZED_TOP_OFFERS_GET_SUCCESS, PERSONALIZED_TOP_OFFERS_GET_FAILURE } from '../actions/types';

const initialState = {
  config,
  isLoading: false,
  isLoaded: false,
  offers: [],
};

/**
 * @param {object} offer
 * @return {object}
 */
const formatOffer = offer => (
  offer.expires && !offer.isOngoing ? {
    ...offer,
    expires: dayjs.parseZone(offer.expires).format(config.dateFormat),
  } : offer
);

export default (state = initialState, action) => {
  switch (action.type) {
    case PERSONALIZED_TOP_OFFERS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        offers: action.payload.response.map(offer => formatOffer(offer)),
      };
    }
    case PERSONALIZED_TOP_OFFERS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        offers: [],
      };
    }
    default: {
      const { options = {} } = action;

      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === PERSONALIZED_TOP_OFFERS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};
